"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
import { AccountSessionMixins } from "@/service/account-session";
import { Component, Mixins, PropSync } from "vue-property-decorator";
let BatchOperateBindVD = class extends Mixins(AccountSessionMixins) {
  get show() {
    for (let item of this._controller.selected) {
      if (!item.marks.is("IS_ADMIN")) {
        return false;
      }
      if (item.marks.is("SHOP_NOT_ALLOW_EDIT_IP")) {
        return false;
      }
    }
    return true;
  }
  mounted() {
    console.log(this._controller.selected);
  }
  editbindvd() {
    this.$emit("editbindvd");
  }
};
__decorateClass([
  PropSync("controller")
], BatchOperateBindVD.prototype, "_controller", 2);
BatchOperateBindVD = __decorateClass([
  Component
], BatchOperateBindVD);
export {
  BatchOperateBindVD as default
};
